module.exports = __webpack_public_path__ + "img/joice-kelly-blue.d6e1e57b.jpg";